import classNames from "classnames";
import { Button } from "components/DesignSystem/Button/Button";
import { CLASSIFICATION_COLUMN_IDS } from "constants/classification";
import { Cell, flexRender, Row } from "react-table-8.10.7";
import type { ClassificationTableRow } from "./ClassificationsSettings";

type MobileClassificationRowProps = {
  row: Row<ClassificationTableRow>;
};

const renderCell = (cell?: Cell<ClassificationTableRow, unknown>) =>
  cell ? flexRender(cell.column.columnDef.cell, cell.getContext()) : null;

export const MobileClassificationRow = ({
  row,
}: MobileClassificationRowProps) => {
  const { isGroup, created_by } = row.original;
  const cellsById = Object.fromEntries(
    row.getVisibleCells().map((cell) => [cell.column.id, cell])
  );

  const handleToggle = () => row.toggleExpanded();

  const content = (
    <div className="t-flex t-items-center t-gap-2 t-w-full">
      {isGroup && renderCell(cellsById[CLASSIFICATION_COLUMN_IDS.ICON])}
      <div className="t-flex t-flex-col t-gap-1 t-flex-1 t-min-w-0">
        {renderCell(cellsById[CLASSIFICATION_COLUMN_IDS.GROUP_CLASS])}
        <div className="t-flex t-flex-wrap t-items-center t-gap-1 t-text-text-30">
          {renderCell(cellsById[CLASSIFICATION_COLUMN_IDS.CREATED_ON])}
          {created_by && (
            <>
              <span>·</span>
              {renderCell(cellsById[CLASSIFICATION_COLUMN_IDS.CREATED_BY])}
            </>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div
      className={classNames(
        "t-flex t-items-center t-gap-2 t-border-0 t-border-b t-border-solid t-border-neutral-0 t-py-3",
        { "t-pl-6": !isGroup }
      )}
    >
      {isGroup && (
        <Button
          type="button"
          customType="ghost"
          onClick={handleToggle}
          className="t-flex-1 t-min-w-0 !t-h-auto !t-px-0 !t-whitespace-normal t-text-left [&>div]:t-w-full [&>div]:t-justify-start [&>div>div]:t-w-full [&>div>div]:t-justify-start"
        >
          {content}
        </Button>
      )}
      {!isGroup && <div className="t-flex-1 t-min-w-0">{content}</div>}

      {renderCell(cellsById[CLASSIFICATION_COLUMN_IDS.ACTIONS])}
    </div>
  );
};
